import { useInfiniteQuery } from "react-query";
import axios from "axios";

const fetchStorePage = async ({ pageParam = 1, merchantId }) => {
  const response = await axios.get(
    `${process.env.REACT_APP_SERVER_URL}/product/store/${merchantId}`,
    { params: { page: pageParam, limit: 12 } }
  );
  return response.data;
};

const usePublicMerchantStore = (merchantId) =>
  useInfiniteQuery(
    ["publicMerchantStore", merchantId],
    ({ pageParam }) => fetchStorePage({ pageParam, merchantId }),
    {
      enabled: !!merchantId,
      getNextPageParam: (lastPage) => {
        const nextPage = (lastPage.currentPage || 1) + 1;
        return nextPage <= (lastPage.totalPages || 0) ? nextPage : undefined;
      },
    }
  );

export default usePublicMerchantStore;
